var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-button"},[_c('span',{staticClass:"copy-button__button",class:{
      active: _vm.isCopied,
      'copy-button__button--is-squared': _vm.squared,
      'copy-button__button--is-primary': _vm.primary,
    },style:(_vm.getButtonStyles),attrs:{"data-clipboard-target":_vm.elementToCopy}},[_c('unicon',{attrs:{"name":_vm.isCopied ? 'check' : 'copy-alt',"fill":_vm.getIconFill}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }